import React, { memo, useCallback, useMemo, useRef } from "react";
import Surface from "./Surface";
import {
	SurfaceActionBarItem,
	SurfaceExpandableCard,
	SurfaceNavBarBrandButton,
	SurfaceNavBarSection,
	SurfaceRoundedCard,
	SurfaceTitle,
} from "./SurfacesCoreUI";

import "./custom-post-surface.css";
import { eventTypes } from "../../hooks/useTrack";
import scrollToTarget from "../../utils/scrollToTarget";
import { PostPurchaseExtensionPreview } from "../CoreUI";
import inExtensionPreview from "../../utils/inExtensionPreview";
import accessibilityProvider from "../../utils/accessibilityProvider";
// import { DEFAULT_SHOP_IMG } from "../../conf";
// import ProductViewBrandCard from "../ProductViewComponents/ProductViewBrandCard";

const CustomPostSurface = memo(
	({ surfaceData, idx, handleSurfaceClose, showFullCard, rootRef }) => {
		const brandDescRef = useRef(null);
		const {
			photo_url: imgUrl,
			heading: title,
			remote_id,
			dismiss_text: dismissText = "Proceed",
			text,
			publisher_details: brandInfo = {},
			module_order,
		} = useMemo(
			() => ({
				...surfaceData,
			}),
			[surfaceData]
		);

		const handleClose = useCallback(() => {
			handleSurfaceClose();
		}, [handleSurfaceClose]);

		const scrollToBrandDesc = useCallback(
			() => scrollToTarget(rootRef, brandDescRef),
			[rootRef]
		);

		const actionBar = useMemo(
			() => ({
				children: (
					<SurfaceActionBarItem
						full
						padded
						className="custom-post-surface-action-bar-item"
						onClick={handleClose}
					>
						<h2>{dismissText}</h2>
					</SurfaceActionBarItem>
				),
			}),
			[handleClose, dismissText]
		);

		const displayEvent = useMemo(
			() => ({
				name: eventTypes.WIDGET_SURFACE_CUSTOM_POST_DISPLAY,
				properties: {
					title,
					remote_id,
					module_position: idx,
					module_order,
				},
			}),
			[title, remote_id, idx, module_order]
		);

		const surfaceTabContent = useMemo(
			() => (
				<>
					<span
						{...accessibilityProvider({
							role: "img",
							name: "Hey",
						})}
					>
						👋
					</span>{" "}
					A message {brandInfo ? `from ${brandInfo.name}` : "for you"}
					, below.
				</>
			),
			[brandInfo]
		);

		const navBar = useMemo(
			() => ({
				children: brandInfo ? (
					<SurfaceNavBarSection onClick={scrollToBrandDesc}>
						<SurfaceNavBarBrandButton
							heading="Message from"
							text={brandInfo.name}
							brandInfo={brandInfo}
						/>
					</SurfaceNavBarSection>
				) : null,
			}),
			[brandInfo, scrollToBrandDesc]
		);

		if (inExtensionPreview) {
			return (
				<PostPurchaseExtensionPreview
					surfaceData={{
						title,
						text,
						imgUrl,
						dismissText,
					}}
					type="custom_post"
					handleClose={handleClose}
				/>
			);
		}

		return (
			<Surface
				handleClose={handleClose}
				imageView={{
					imgUrl,
				}}
				actionBar={actionBar}
				displayEvent={displayEvent}
				showSurfaceTab={false}
				surfaceTabContent={surfaceTabContent}
				showFullCard={showFullCard}
				navBar={navBar}
				className="custom-post-surface-container"
			>
				<SurfaceRoundedCard showFullCard={showFullCard}>
					<SurfaceTitle>{title}</SurfaceTitle>
					<SurfaceExpandableCard
						triggerExpand={!text || text.length < 150 || false}
						className="custom-post-surface-description"
					>
						{text}
					</SurfaceExpandableCard>
					{/* <section className="custom-post-surface-description">
						{text}
					</section> */}
					{/* {brandInfo && (
						<section
							className="custom-post-surface-scroll-btn"
							onClick={scrollToBrandDesc}
						>
							<img
								src={brandInfo?.logo_url || DEFAULT_SHOP_IMG}
								alt=""
							></img>
							Shop Info ↓
						</section>
					)} */}
				</SurfaceRoundedCard>
				{/* <div ref={brandDescRef} />
				{brandInfo && (
					<ProductViewBrandCard brand={brandInfo} inSurface />
				)} */}
			</Surface>
		);
	}
);

export default CustomPostSurface;
